export enum PaymentHistoryProperties {
  Start = 'start',
  Description = 'description',
  EndDate = 'endDate',
  Total = 'total',
  SubTotal = 'subTotal',
  Tax = 'tax',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  Name = 'name',
  AccountId = 'accountId',
  PaymentId = 'paymentId',
}
export enum PaymentHistoryMetaProperties {}
